/**
 * Aurum & Ash — Collection Page JS
 * Handles: sort-by select
 */
(function () {
  var sortSelect = document.querySelector('[data-sort-select]');
  if (!sortSelect) return;

  sortSelect.addEventListener('change', function () {
    var url = new URL(window.location);
    url.searchParams.set('sort_by', sortSelect.value);
    window.location = url.toString();
  });
})();
